import { THEME_NAMES } from "./config";
import { assetPackIds } from "nemuru-components";

export const realTurfTheme = {
  zendeskCustomerSupport: false,
  themeName: THEME_NAMES.real_turf,
  logoUrl:
    "https://mcusercontent.com/9fe5713c5d971de550dce4ea7/images/2fab7ff3-7251-9ef0-d9ae-9a8370d74845.png",
  palette: {
    primary: {
      main: "#434343",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#ee2737",
      contrastText: "#ffffff",
    },
    dark: {
      main: "#eeeeee",
      contrastText: "#525252",
      accent: "#ff0000",
      imageBackgroundOpacity: 0.85,
    },
    text: {
      title: "#3c3c3c",
      primary: "#525252",
      secondary: "#77787b",
    },
    status: {
      sent: "#525252",
      denied: "#ee2737",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#f6f6f6",
  shadows: [
    "none",
    "none",
    "none", // 2 buttons
    "none", // 3 papers soft
    "0px 0px 20px 0px rgba(0 0 0 .5)", // 4 buttons hover
    "none", // 5
    "0px 2px 0px 0px rgb(239 61 69)", // 6 papers header
  ],
  customBorderRadius: {
    button: 2,
    paper: 0,
  },
  typography: {
    fontFamily: "proxima_nova, Helvetica",
  },
};
